var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"block px-4 py-3 text-sm leading-5 text-white rounded-md cursor-pointer select-none hover:bg-gray-800 dark:text-black dark:hover:bg-gray-100 flex items-center",staticStyle:{"min-width":"120px"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }